import { useMutation } from '@tanstack/react-query'
import * as charitiesAPI from '@/api/charitiesAPI'

export function useValidateCharity() {
  return useMutation({
    mutationFn: ({
      token,
      charityNumber,
    }: {
      token: string
      charityNumber: string
    }) => charitiesAPI.validateCharity(token, charityNumber),
  })
}
